import { Pipe, PipeTransform } from '@angular/core';
import { ProfessionalJob } from '@adeo/ngx-kozikaza-api';

@Pipe({
  name: 'proJobName'
})
export class ProJobNamePipe implements PipeTransform {

  transform(value: string | ProfessionalJob, ...args: unknown[]): string {
    return (typeof value !== 'string') ? value.name : '';
  }

}
